import { LOAD_CART, ADD_ITEM, REMOVE_ITEM, UPDATE_ITEM } from '../actions/cartActions'

let initialState = {
  itemAddedModal: false,
  items: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case LOAD_CART:
      return { ...state }
    case ADD_ITEM:
      return { ...state, items: action.items }
    case REMOVE_ITEM:
      return { ...state, items: state.items.filter(item => {
        let var1 = item.productID ? item.productID : item.productName
        return var1 !== action.id 
      }) }
    case UPDATE_ITEM:
      return { ...state, items: action.items }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/cartReducer.js